import { Box, Button, Grid, styled, TextField } from "@mui/material";

const modalStyle = {
    position: 'absolute',
    top: '25%',
    left: '25%',
    width: '50%',
    height: '39%',
    bgcolor: 'background.paper',
    textAlign: 'center',
    borderRadius: '15px',
};

const ModalLabel = styled(Box)(() => ({
    backgroundColor: '#41DBCE',
    fontSize: '1.3rem',
    color: '#FFFFFF',
    height: '2.2rem',
    paddingTop: '0.5rem',
    borderRadius: '15px 15px 0 0',
    textAlign: 'left',
    paddingLeft: '1rem',
    boxSizing: 'content-box'
}));

const InputBox = styled(Box)(() => ({
    backgroundColor: '#F2F2F2',
    textAlign: 'center',
    fontSize: '1.5rem',
    height: '6rem',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: '2rem',
}));

const TextFieldBox = styled(Box)(() => ({
    textAlign: 'center',
    fontSize: '1.2rem',
    color: '#595959',
    width: '90%',
}));

const TextFieldLabel = styled(Grid)(() => ({
    backgroundColor: '#595959',
    color: '#FFFFFF',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
}));

const TextFieldForm = styled(Grid)(() => ({
    backgroundColor: '#FFFFFF',
}));

const DataInputForm = styled(TextField)(() => ({
    '& .MuiOutlinedInput-root': {
        '& fieldset': {
            border: 'none',
        },
        '&:hover fieldset': {
            border: 'none',
        },
        '&.Mui-focused fieldset': {
            border: 'none',
        },
    },
}))

const CancelButton = styled(Button)(() => ({
    backgroundColor: '#BFBFBF',
    color: '#000000',
    textAlign: 'center',
    fontSize: '1rem',
    fontWeight: 'bold',
    height: '2.5rem',
    width: '10rem',
    borderRadius: '100rem'
}));

const SaveButton = styled(Button)(() => ({
    backgroundColor: '#01CFBE',
    color: '#FFFFFF',
    textAlign: 'center',
    fontSize: '1rem',
    fontWeight: 'bold',
    height: '2.5rem',
    width: '10rem',
    borderRadius: '100rem'
}));

export { modalStyle, ModalLabel, InputBox, TextFieldBox, TextFieldLabel, TextFieldForm, DataInputForm, CancelButton, SaveButton }
